module.exports = __webpack_public_path__ + "static/img/submit_success.fde5e4e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/submit_success.svg
// module id = +wdC
// module chunks = 0